import { useState } from 'react';
import { useDebouncedValue } from './useDebouncedValue';

/** Задержка поиска: запрос уходит, когда набор строки замер */
const SEARCH_DEBOUNCE_MS = 300;

/** Строка поиска, по которой выдачу набирает запрос на сервер */
export type ServerSearch = {
  /** Набираемая строка — для поля поиска */
  value: string;
  onChange: (value: string) => void;
  /** Строка для запроса: без краевых пробелов и с задержкой на время набора */
  applied: string;
};

/**
 * Строка для запроса на сервер из набираемой: без краевых пробелов и с задержкой на время набора.
 * Нужна тому, у кого набираемую строку уже держит своё состояние, — окну выбора `useSelectionDialogState`.
 */
export const useDebouncedSearch = (value: string) => useDebouncedValue(value.trim(), SEARCH_DEBOUNCE_MS);

/**
 * Строка поиска, по которой выдачу набирает запрос на сервер: поле выбора, вложенный список.
 * Набранное уходит в запрос не на каждый символ, а когда набор замер.
 */
export const useServerSearch = (): ServerSearch => {
  const [value, setValue] = useState('');
  const applied = useDebouncedSearch(value);

  return { value, onChange: setValue, applied };
};
